<template>
  <v-flex d-flex>
    <v-container fluid>
      <v-fab-transition>
        <v-btn fixed bottom right dark fab color='pink' :loading='loading'>
          <v-icon>cached</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-card>
        <v-card-title primary-title>
          <h2>{{$route.meta.title}}</h2>
          <div class='spacer'></div>
        </v-card-title>
        <v-layout wrap justify-space-around fill-height>
          <v-flex xs5 sm2 md4>
            <v-autocomplete
              v-model='client'
              :items='clients'
              :search-input.sync='searchClient'
              hide-selected
              hint='Maximum of 5 tags'
              label='Select a Client'
              multiple
              persistent-hint
              small-chips
              prepend-inner
            >
             <template v-slot:no-data>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      No client matched
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs5 sm2 md4>
            <v-autocomplete
              v-model='exchange'
              :items='exchanges'
              :search-input.sync='search'
              hide-selected
              hint='Maximum of 5 tags'
              label='Search Exchange'
              multiple
              persistent-hint
              small-chips
              prepend-inner
            >
               <template v-slot:no-data>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      No exchange matched
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs5 sm2 md2>
            <v-btn color='primary' style='margin-left: 40px' :loading='loading' @click='searchBot()'>Search</v-btn>
          </v-flex>
        </v-layout>
        <br>
      </v-card>
      <v-card-text v-if='loading' class='elevation-1 white text-xs-center pa-3' style='transform: translateY(0px);'>
        <v-progress-circular indeterminate color='primary'></v-progress-circular>
      </v-card-text>
      <v-card v-if='!loading'>
        <ReportTable
          ref='reportTables'
          :items='reportTables'
        />
      </v-card>
    </v-container>
  </v-flex>
</template>

<script>
import MongoService from '../../services/mongo.service';
import MongoConnector from '../../services/mongo-connector.service';
import MessageDialog from '../../libs/message-dialog/';
import Alert from '../../libs/alert'
import ReportTable from './ReportTable'
export default {
  data() {
    const service = new MongoConnector(null, 'accounts', {});
    return {
      search: null,
      searchClient: null,
      loading: true,
      service,
      dataReady: false,
      exchanges: [],
      exchange: [],
      clients: [],
      client: [],
      reportTables: [],
      dialog: false,
      totalOrders: 0,
      totalCancelledOrders: 0,
      dialogSuccessClass: null
    };
  },
  async beforeMount() {
    this.loading = true
    try {
      const exchangeList = await MongoService.aggregate({
        collection: 'accounts',
        aggregate: [
          { $group: { _id: null, exchange: { $addToSet: '$exchange' } } },
          { $unwind: '$exchange' },
          { $sort: { 'exchange': 1 } },
          { $group: { _id: null, exchange: { $push: '$exchange' } } },
          { $project: { 'exchange': 1, _id: 0 } }
        ]
      })
      this.exchanges = exchangeList[0].exchange;

      const clients = await MongoService.aggregate({
        collection: 'accounts',
        aggregate: [
          { '$match': { 'client_id': { '$ne': null} }},
          { '$sort': { 'client_id': 1 } },
          { '$group': { '_id': null, 'client':  { '$addToSet': '$client_id' } }}
        ]
      })

      this.clients = clients[0].client
    } catch (e) {}
    this.loading = false
  },
  async mounted () {
    this.searchBot()
  },
  methods: {
    async searchBot() {
      this.loading = true
      const filter = {}

      filter['$and'] = []
      if (this.exchange.length > 0) {
        const accountFilter = this.exchange.map(a => ({
          exchange: { $regex : a.toLowerCase()}
        }))
        filter['$and'].push({ '$or': accountFilter })
      }
      if (this.client.length > 0) {
        const accountFilter = this.client.map(a => ({
          client_id: { $regex : a }
        }))
        filter['$and'].push({ '$or': accountFilter })
      }

      if (filter['$and'].length <= 0) delete filter['$and']

      const [reports, bots] = await Promise.all([MongoService.aggregate({
        collection: 'accounts',
        aggregate: [
          { '$match': filter },
          { '$match': { 'type': 'report' } }
        ]
      }),
      MongoService.aggregate({
        collection: 'accounts',
        aggregate: [
          { '$match': { 'type': 'bot' } }
        ]
      })])

      const result = reports.map(report => {
        report.bots = []

        if (report.exchange_username) {
          report.bots = bots
          .filter(b => b.exchange_username === report.exchange_username && b.exchange === report.exchange)
          .map(b => `${b.account_id} (${b.bot_roles ? b.bot_roles : '-'})`)
        }
        return report
      })

      this.reportTables = result.map(c => ({
        _id: c._id,
        accountId: c.account_id,
        exchange: c.exchange,
        exchangeUsername: c.exchange_username,
        type: c.type,
        bots: c.bots,
        client: c.client_id,
        bot_roles: c.bot_roles
      }))

      this.loading = false
    },
  },
  components: {
    ReportTable
  }
};
</script>